import UseQuery from "@/src-refactor/modules/shared/hooks/use-query.hook";
import { Paper, Typography } from "@mui/material";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";
import { IconInfoCircle, IconX } from "@tabler/icons-react";
import { debounce } from "lodash";
import { useEffect, useCallback, useMemo } from "react";
import toast, { ToastOptions } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

type options = "create" | "edit";
interface IQuery {
  [key: string]: options | undefined;
}
const usePropertyLoadActionsFromQuery = () => {
  const { query } = UseQuery();
  const navigate = useNavigate();
  const location = useLocation();
  const queryKey = useMemo(() => JSON.stringify(query), [query]);

  const onLoadActions = useCallback(
    debounce((query: any) => {
      if (query["create"]) {
        const element = document.getElementById(
          "create-property-modal-shortcut-button"
        );
        if (element) {
          element.click();
        }
      }
      if (query["redirectFrom"]) {
        if (query["redirectFrom"] === "property-v1") {
          setTimeout(() => {
            toastInfo(
              "Parece que intentaste acceder al módulo antiguo de propiedades, este módulo fue oficialmente deshabilitado el 06 de agosto del 2025 para continuar trabajando sobre el nuevo que es mucho mejor, más fiable y seguro.",
              () => {
                navigate(location.pathname, { replace: true });
              }
            );
          }, 300);
        }
      }
    }, 700),
    []
  );

  useEffect(() => {
    onLoadActions(query);
    return () => {
      onLoadActions.cancel();
    };
  }, [queryKey]);

  return {};
};

export default usePropertyLoadActionsFromQuery;

export const toastInfo = (
  message: string,
  onDismiss: () => void,
  extraOptions?: ToastOptions
) => {
  const baseOptions: ToastOptions = {
    duration: 60_000, // 1 minuto
    position: "top-center",

    ...extraOptions
  };

  let dismissed = false;
  const handleDismiss = () => {
    if (dismissed) return;
    dismissed = true;
    toast.dismiss();
    onDismiss();
  };

  toast.custom(
    () => (
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1,
          px: 2,
          minWidth: 280,
          maxWidth: 600,
          borderRadius: "10px"
        }}
      >
        <MxIcons children={<IconInfoCircle />} color="info.main" size={20} />
        <MxTypography
          variant="overline"
          sx={{ flex: 1, fontSize: 12, color: "grey.700" }}
        >
          {message}
        </MxTypography>
        <MxIcons
          children={<IconX />}
          color="grey.800"
          size={20}
          onClick={() => {
            handleDismiss();
          }}
        />
      </Paper>
    ),
    baseOptions
  );

  if (baseOptions.duration && baseOptions.duration > 0) {
    setTimeout(() => {
      handleDismiss();
    }, baseOptions.duration);
  }
};
